import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../components/ui/alert-dialog';

export const API = process.env.REACT_APP_BACKEND_URL;
export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

/** Inline rendering of the custom Dirham "D" — a styled char that visually mimics "Dh". */
export const DhSymbol = ({ className = '' }) => (
  <span
    className={`inline-block font-serif font-bold tracking-tighter ${className}`}
    style={{ letterSpacing: '-0.06em' }}
    aria-label="Dirham"
  >
    Dh
  </span>
);

export const fmtAmount = (n) =>
  Number(n || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const fmtDateLong = (iso) => {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch { return iso; }
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const BRAND_META = {
  vynce: { label: 'Vynce', cls: 'bg-rose-100 text-rose-700 border-rose-200', btn: 'bg-rose-600 hover:bg-rose-700' },
  stars_n_bars: { label: 'Stars N Bars', cls: 'bg-blue-100 text-blue-700 border-blue-200', btn: 'bg-blue-700 hover:bg-blue-800' },
};
export const brandMeta = (b) => BRAND_META[b] || BRAND_META.vynce;

// Iframe-safe confirmation dialog (window.confirm is blocked inside sandboxed
// preview iframes, so we use an in-app AlertDialog instead).
export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = 'Delete', onConfirm, testid }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid={testid}>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="confirm-cancel">Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          className="bg-rose-600 hover:bg-rose-700"
          data-testid="confirm-delete"
        >{confirmLabel}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

// Iframe-safe file open: open the blob in a new top-level tab (sandboxed
// iframes block programmatic <a download> clicks); fall back to anchor download.
export const openBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank');
  if (!win) {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const periodLabelFromDate = (iso, type) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (type === 'weekly') {
    const onejan = new Date(d.getFullYear(), 0, 1);
    const week = Math.ceil((((d - onejan) / 86400000) + onejan.getDay() + 1) / 7);
    return `Week ${week}, ${d.getFullYear()}`;
  }
  return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
};

// Advance an ISO date (YYYY-MM-DD) by n months, clamping day overflow safely.
export const addMonthsIso = (iso, n = 1) => {
  if (!iso) return todayIso();
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(y, (m - 1) + n, 1);
  const lastDay = new Date(dt.getFullYear(), dt.getMonth() + 1, 0).getDate();
  dt.setDate(Math.min(d, lastDay));
  const yyyy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, '0');
  const dd = String(dt.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const blankClient = { name: '', contact_person: '', email: '', phone: '', address: '', trn: '' };
export const emptyItem = () => ({ description: '', quantity: 1, unit_price: 0 });
